module.exports = __webpack_public_path__ + "static/media/admin_icon.bedfa490.png";